import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  MainResponse,
  CollectedData,
  ResourcesContent,
  SolutionSessionMessage,
  LubavSessionType,
} from '@backrs_ui/grow-ui/src/models/models';

import {
  setMainResponseData,
  setCollectedData,
  setResourcesContent,
  setStreamingComplete,
} from '../boxData/boxData';
import { setIsLoading, setSessionId, setSolutionSessionMessages } from '../coachLubav/coachLubav';
import { createSessionAction } from '../lubavSessionState/lubavSessionState.utils';
import { setChatMode } from '../solutionSession/solutionSession';

export const loadSessionData = createAsyncThunk(
  'solutionSession/loadSessionData',
  async (
    {
      sessionData,
      activeSession,
    }: {
      sessionData: {
        session_id: number;
        session_type: LubavSessionType;
        main_response: MainResponse | null;
        collected_data: CollectedData;
        additional_resources: ResourcesContent;
        messages: SolutionSessionMessage[];
        finished: boolean;
      };
      activeSession: LubavSessionType;
    },
    { dispatch },
  ) => {
    // return early if the active session doesn't match the session data
    if (activeSession !== sessionData.session_type) {
      return sessionData;
    }

    dispatch(createSessionAction(setSessionId, activeSession)(sessionData.session_id));

    if (sessionData.main_response) {
      dispatch(createSessionAction(setMainResponseData, activeSession)(sessionData.main_response));
    }

    if (sessionData.finished) {
      dispatch(createSessionAction(setChatMode, activeSession)(true));
    }

    if (sessionData.collected_data) {
      dispatch(createSessionAction(setCollectedData, activeSession)(sessionData.collected_data));
    }

    if (sessionData.additional_resources) {
      dispatch(
        createSessionAction(setResourcesContent, activeSession)(sessionData.additional_resources),
      );
    }

    if (sessionData.messages) {
      dispatch(
        createSessionAction(setSolutionSessionMessages, activeSession)(sessionData.messages),
      );
    }

    dispatch(
      createSessionAction(setStreamingComplete, activeSession)(sessionData.finished || false),
    );

    dispatch(createSessionAction(setIsLoading, activeSession)(false));

    return sessionData;
  },
);
